import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Please check your .env file.');
  throw new Error('Missing Supabase configuration');
}

// Validate URL format
const urlPattern = /^https?:\/\/.+/;
if (!urlPattern?.test(supabaseUrl)) {
  console.error('Invalid Supabase URL format:', supabaseUrl);
  throw new Error('Invalid supabaseUrl: Must be a valid HTTP or HTTPS URL.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
